import { createContext } from 'react';

const DataRowContext = createContext();

export default DataRowContext;
